import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  commonApiCall,
  conversationDetails,
  showErrorToast,
  showSuccessToast,
  paginationDropdown,
  DashboardPagesRoutes,
  encryptData,
  decryptData,
  commonApiCallHeaders,
  // getCookieValue,
  segmentTracking,
  checkAccess,
  formatDateInTimezone,
  setItem,
  validateEmail,
  getItem,
  agentDetils,
  setAgencyFilters,
} from "../../../utlis";
import { isEmpty } from "lodash";
import Layout from "../../../components/layoutComponents/layout";
import { withRouter, Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import Pagination from "react-js-pagination";
import Select from "react-select";
import {
  API_POINT,
  API_POINT_PAYMENT,
  API_POINT_UNDERWRITE,
} from "../../../config/config";
// import moment from "moment";;
import AuthorizePayment from "../../registration/authorizePayment";
import { Modal, OverlayTrigger, Popover } from "react-bootstrap";
import { TransactionTableLoader } from "../../../components/skeletonLoaders";
import AccessDenied from "../../accessDenied";
import Search from "../../../components/layoutComponents/Search";
import { CSVLink } from "react-csv";
import moment from "moment";
import InviteAgentModel from "./inviteAgnetModel";
import { LeafLoader } from "../../../components/skeletonLoaders/ilifeLogoLoader";
import DeleteModel from "../../emailCampaign/emailModels/deleteModel";
import errorMessages from "../../../redux/actions/errorMessages";
import TopPerformerStatics from "../statics/topPerformerStatics";
import DateFilterModel from "./dateFilterModel";
import ResendInviteImage from "../../../assets/images/resend_invite.svg";
import cancelInvite from "../../../assets/images/cancel_invite.svg";
import ChangePayer from "../../../assets/images/change_payer.svg";
import ShowMoreOptions from "../enterprise/showMoreOptions";
import ColumnModel from "../../../components/modelComponents/columnModel";
import BottomToaster from "../../../components/layoutComponents/bottomToaster";
import { toast } from "react-toastify";

function MyAgents({
  commonApiCall,
  sign_in,
  planData,
  commonApiCallHeaders,
  agentDetils,
  setAgencyFilters,
  selected_agency_filter,
  ...props
}) {
  const agentTypeOptions = [
    { value: "ambassador", label: "Ambassador", key: "ambassador" },
    { value: "professional-plus", label: "Pro+", key: "Pro+" },
  ];
  const [page, setPage] = useState({
    totalItemsCount: 1,
    activePage: 1,
    perPage: 10,
    pageRangeDisplayed: null,
    itemsCountPerPage: null,
  });
  const [changePayerValue, setChangePayerValue] = useState({
    freeAcountRemaining: "",
    freeChildPrice: "",
  });
  const [paymentTypeOptions, setPaymentTypeOptions] = useState([]);
  const [managerialViewList, setAgentPayoutHistories] = useState([]);
  const [loader, setLoader] = useState(false);
  const [isCardDetails, setIsCardDetails] = useState(false);
  const [agentListLoader, setAgentListLoader] = useState(false);
  const [showDeleteModel, setDeleteModel] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [agentId, setAgentId] = useState(null);
  const [inviteCode, setInviteCode] = useState(null);
  const [showRemoveModel, setShowRemoveModel] = useState(false);
  const [clearSelectedRows, setClearSelectedRows] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    agentType: { value: "professional-plus", label: "Pro+", key: "Pro+" },
    referralFees: "",
    inviteLink: "",
    remainingProSeats: 0,
    paymentType: null,
    errors: {},
  });
  const [isInvitingModel, setInvitingModel] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isChangeInInviteModel, setIsChangeInInviteModel] = useState(false);
  const [showInviteModel, setShowInviteModel] = useState(false);
  const [isCsvDataLoading, setIsCsvDataLoading] = useState(false);
  const [csvData, setCsvData] = useState([]);
  const [isSetting, setSetting] = useState(false);
  const [showMoreOption, setShowMoreOption] = useState(false);
  const [showPayerOption, setShowPayerOption] = useState(false);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("desc");
  const [productSort, setProductSort] = useState("createdDate");
  const [filterType, setFilterType] = useState("all");
  const [showDateModal, setDateModal] = useState(false);
  const [dateValue, setDateValue] = useState(null);
  const [dateFilter, setDateFilter] = useState({ startDate: "", endDate: "" });
  const [searchDateFilter, setSearchDateFilter] = useState(false);
  const [isActivityInMoreOption, setIsActivityInMoreOption] = useState(false);
  const [topPerformanceRender, setTopPerformanceRender] = useState(false);
  const [checkedColumns, setCheckedColumns] = useState([]);
  const [columnName, setcolumnName] = useState("");
  const [columnModal, setColumnModal] = useState(false);

  async function fetchColumns() {
    let API_URL = API_POINT_UNDERWRITE + "/getAgencyColumnsForCrm";
    let response = await commonApiCall(API_URL, "", "get", null, true);
    if (response.status === 200) {
      setCheckedColumns(response.data.data || []);
    }
  }

  const settinghandler = () => {
    setSetting(!isSetting);
  };

  // let hideColumnStoredData = JSON.parse(getItem("hideAgencyTableColumn"));
  // const [hideColumn, setHideColumns] = useState({
  //   subscriptionPaidBy: hideColumnStoredData?.subscriptionPaidBy || false,
  //   agentName: hideColumnStoredData?.agentName || false,
  //   agentType: hideColumnStoredData?.agentType || false,
  //   emailsCount: hideColumnStoredData?.emailsCount || false,
  //   callsCount: hideColumnStoredData?.callsCount || false,
  //   textSent: hideColumnStoredData?.textSent || false,
  //   clientsCount: hideColumnStoredData?.clientsCount || false,
  //   submittedApplications: hideColumnStoredData?.submittedApplications || false,
  //   totalApplications: hideColumnStoredData?.totalApplications || false,
  //   policiesPaid: hideColumnStoredData?.policiesPaid || false,
  //   recentActivities: hideColumnStoredData?.recentActivities || false,
  //   applicants : hideColumnStoredData?.applicants || false,
  //   signupDate : hideColumnStoredData?.signupDate || false,
  //   email : hideColumnStoredData?.email || false
  // });

  // const {
  //   email,
  //   signupDate,
  //   applicants,
  //   subscriptionPaidBy,
  //   agentName,
  //   agentType,
  //   emailsCount,
  //   callsCount,
  //   textSent,
  //   clientsCount,
  //   submittedApplications,
  //   totalApplications,
  //   policiesPaid,
  //   recentActivities,
  // } = hideColumn;
  const renderTooltiptext = (id, content) => {
    return (
      <Popover id={id}>
        <Popover.Content className='tooltip-outer'>{content}</Popover.Content>
      </Popover>
    );
  };

  const getUserProfileDetails = async () => {
    setInvitingModel(true);
    let response = await commonApiCall(
      API_POINT + "/getUsersProfile",
      "",
      "get",
      null,
      true
    );
    if (response.data.status.code === 200) {
      let tempOptions = [
        {
          value: "free",
          label: `Use free invite (${response.data.data.freeAcountRemaining} invites remaining)`,
        },
        {
          value: "agent",
          label: `Billed to Agency (Added to your subscription for $${response.data.data.freeChildPrice}/month)`,
        },
        {
          value: "pro_plus",
          label: `Billed to Agent  ($${response.data.data.freeChildPrice}/month)`,
        },
      ];
      if (response.data.data.freeAcountRemaining < 1) {
        tempOptions.splice(0, 1);
        setPaymentTypeOptions(tempOptions);
      } else {
        setPaymentTypeOptions(tempOptions);
      }
      setFormData({
        ...formData,
        inviteLink: response.data.data.link,
        remainingProSeats: response.data.data.freeAcountRemaining,
        paymentType:
          response.data.data.paymentType &&
          tempOptions.filter((x) => x.value === response.data.data.paymentType),
        emailContent: {
          subject: response.data.data.emailTemplateSub,
          body: response.data.data.emailTemplateBody,
        },
      });
      setInvitingModel(false);
    } else {
      showErrorToast(response.data.status.message);
    }
  };

  const getLeadStatistics = async () => {
    if (sign_in?.data?.id !== undefined) {
      let response = await commonApiCall(
        API_POINT + "/getLeadCount?agentId=" + sign_in?.data?.id,
        "",
        "get",
        null,
        false
      );
      if (response.data.status.code === 200) {
        // let { data } = response.data;
        // setActivePaymentGateway(data.activePaymentGateway);
      } else {
        showErrorToast(response.data.status.message);
      }
    }
  };

  const navigateToAgentDetails = (row) => {
    if (
      row?.createdDate === "N/A" ||
      (!row.PaymentDone && row.PaymentByManager && row.PaymentRequired)
    ) {
      return false;
    } else {
      props.history.push(DashboardPagesRoutes.AGENTDETAILS);
      let agentDetails = {
        id: row.Id,
        agentName: row.firstName,
        agentType: row.agentType,
        repCode: row.RepresentativeCode,
        filterType: filterType,
        dateFilter: dateFilter,
        searchDateFilter: searchDateFilter,
        path: "dashboard",
        from: "Agency View",
      };
      setItem("agentDetails", JSON.stringify(agentDetails));
      agentDetils(agentDetails);
    }
  };

  // const handleHideColumn = (e, checked) => {
  //   setHideColumns({
  //     ...hideColumn,
  //     [e.target.name]: !checked,
  //   });
  //   let hideAgencyTableColumn = {
  //     ...hideColumn,
  //     [e.target.name]: !checked,
  //   };
  //   setItem("hideAgencyTableColumn", JSON.stringify(hideAgencyTableColumn));
  // };

  async function handleCheckColumn(name, checked, id) {
    let isActive = checked === true ? false : true;
    let API_URL = `${API_POINT_UNDERWRITE}/agencyColumnsForCrm?agencyColumnId=${id}&is_Active=${isActive}`;
    let response = await commonApiCall(API_URL, "", "put", null, true);
    if (response.status === 200) {
      showSuccessToast(response.data.status.message);
      setSetting(false);
      fetchColumns();
      await getMyAgents(
        page.perPage,
        page.activePage,
        search,
        sort,
        productSort
      );
    }
  }

  const checkColumnOmit = (columnName) => {
    const foundItem = checkedColumns.find((item) => item.slug === columnName);
    if (foundItem?.isActive) {
      return true;
    } else {
      return false;
    }
  };

  const generateCheckBox = (lable, name, checked, columnType, id) => {
    return (
      <li key={name}>
        <span className=' d-flex flex-row align-items-center custom-checkbox sm-checkbox  checkbox-green'>
          <label>
            <input
              type='checkbox'
              name={name}
              id={name}
              checked={checked}
              onChange={(e) => handleCheckColumn(name, checked, id)}
              //disabled={columnType === "fixed"}
            />
            <span></span>
            <span className='setting-checkbox-label'>{lable}</span>
          </label>
          {/* {columnType == "Advance" &&
            checkAccess(planData, "CUSTOM_COLUMNS") && (
              <svg
                // className=' material-icons delete-draft cursor-icon m1-auto mr-2 flex-shrink-0'
                className={`${
                  from == "Agency View" && "call-none"
                } material-icons delete-draft cursor-icon m1-auto mr-2 flex-shrink-0`}
                width='13px'
                height='15px'
                onClick={() => {
                  setShowRemoveModel(true);
                  setDeletingColumnName(name);
                }}
              >
                <g transform='matrix(1 0 0 1 -1086 -343 )'>
                  <path
                    d='M 4.642857142857143 5.625  C 4.642857142857143 5.625  4.642857142857143 11.71875  4.642857142857143 11.71875  C 4.642857142857143 11.976562505587935  4.433928576963289 12.1875  4.178571428571429 12.1875  C 3.9232142801795686 12.1875  3.714285714285714 11.976562505587935  3.714285714285714 11.71875  C 3.714285714285714 11.71875  3.714285714285714 5.625  3.714285714285714 5.625  C 3.714285714285714 5.3671874944120646  3.9232142801795686 5.15625  4.178571428571429 5.15625  C 4.433928576963289 5.15625  4.642857142857143 5.3671874944120646  4.642857142857143 5.625  Z M 6.964285714285715 5.625  C 6.964285714285715 5.625  6.964285714285715 11.71875  6.964285714285715 11.71875  C 6.964285714285715 11.976562505587935  6.75535714839186 12.1875  6.5 12.1875  C 6.24464285160814 12.1875  6.035714285714286 11.976562505587935  6.035714285714286 11.71875  C 6.035714285714286 11.71875  6.035714285714286 5.625  6.035714285714286 5.625  C 6.035714285714286 5.3671874944120646  6.24464285160814 5.15625  6.5 5.15625  C 6.75535714839186 5.15625  6.964285714285715 5.3671874944120646  6.964285714285715 5.625  Z M 9.285714285714286 5.625  C 9.285714285714286 5.625  9.285714285714286 11.71875  9.285714285714286 11.71875  C 9.285714285714286 11.976562505587935  9.076785719820432 12.1875  8.821428571428571 12.1875  C 8.56607142303671 12.1875  8.357142857142858 11.976562505587935  8.357142857142858 11.71875  C 8.357142857142858 11.71875  8.357142857142858 5.625  8.357142857142858 5.625  C 8.357142857142858 5.3671874944120646  8.56607142303671 5.15625  8.821428571428571 5.15625  C 9.076785719820432 5.15625  9.285714285714286 5.3671874944120646  9.285714285714286 5.625  Z M 9.213169642857142 0.7306640781462193  L 10.278125354221888 2.34375  C 10.278125354221888 2.34375  12.303571428571429 2.34375  12.303571428571429 2.34375  C 12.689508934106145 2.34375  13 2.65869140625  13 3.046875  C 13 3.4365234430879354  12.689508934106145 3.75  12.303571428571429 3.75  C 12.303571428571429 3.75  12.071428571428571 3.75  12.071428571428571 3.75  C 12.071428571428571 3.75  12.071428571428571 12.65625  12.071428571428571 12.65625  C 12.071428571428571 13.951171897351742  11.032589307853154 15  9.75 15  C 9.75 15  3.25 15  3.25 15  C 1.9679910625730244 15  0.9285714285714285 13.951171897351742  0.9285714285714285 12.65625  C 0.9285714285714285 12.65625  0.9285714285714285 3.75  0.9285714285714285 3.75  C 0.9285714285714285 3.75  0.6964285714285714 3.75  0.6964285714285714 3.75  C 0.3119419642857142 3.75  0 3.4365234430879354  0 3.046875  C 0 2.65869140625  0.3119419642857142 2.34375  0.6964285714285714 2.34375  C 0.6964285714285714 2.34375  2.72245534828731 2.34375  2.72245534828731 2.34375  C 2.72245534828731 2.34375  3.7868303571428577 0.7306640781462193  3.7868303571428577 0.7306640781462193  C 4.088616060359137 0.2741308696568012  4.596428726400648 0  5.139062677110944 0  C 5.139062677110944 0  7.860937322889055 0  7.860937322889055 0  C 8.403571273599352 0  8.911383939640862 0.2741601783782244  9.213169642857142 0.7306640781462193  Z M 4.947544642857143 1.5105469152331352  C 4.947544642857143 1.5105469152331352  4.396205357142858 2.34375  4.396205357142858 2.34375  L 8.603794642857142 2.34375  C 8.603794642857142 2.34375  8.052455357142858 1.5105469152331352  8.052455357142858 1.5105469152331352  C 8.008928571428571 1.445507851894945  7.9363837486931255 1.40625  7.860937322889055 1.40625  C 7.860937322889055 1.40625  5.139062677110944 1.40625  5.139062677110944 1.40625  C 5.0636162513068745 1.40625  4.964955357834697 1.445507851894945  4.947544642857143 1.5105469152331352  Z M 2.3214285714285716 3.75  C 2.3214285714285716 3.75  2.3214285714285716 12.65625  2.3214285714285716 12.65625  C 2.3214285714285716 13.174804709851742  2.7372544620718275 13.59375  3.25 13.59375  C 3.25 13.59375  9.75 13.59375  9.75 13.59375  C 10.263616093567439 13.59375  10.678571428571429 13.174804709851742  10.678571428571429 12.65625  C 10.678571428571429 12.65625  10.678571428571429 3.75  10.678571428571429 3.75  L 2.3214285714285716 3.75  Z '
                    fillRule='nonzero'
                    fill='#9b9b9b'
                    stroke='none'
                    transform='matrix(1 0 0 1 1086 343 )'
                  ></path>
                </g>
              </svg>
            )} */}
        </span>
      </li>
    );
  };

  const payAgentSubscription = async (paymentGatewayName, paymentProfileId) => {
    let body = {
      customerPaymentProfileId: paymentGatewayName
        ? await encryptData(paymentProfileId)
        : isNaN(Number(paymentProfileId))
        ? paymentProfileId
        : await encryptData(paymentProfileId),

      paymentGatewayName: "STRIPE",
    };
    setLoader(true);
    try {
      let response = await commonApiCall(
        API_POINT_PAYMENT + `/subscriptionByManager?agentId=${agentId}`,
        body,
        "post",
        null,
        true
      );
      if (response.data.status.code === 200) {
        showSuccessToast(response.data.status.message);
        getMyAgents(page.perPage, page.activePage, search, sort, productSort);

        setIsCardDetails(false);
        setLoader(false);
      } else {
        getMyAgents(page.perPage, page.activePage, search, sort, productSort);
        showErrorToast(response.data.status.message);
        setIsCardDetails(false);
        setLoader(false);
      }
    } catch (error) {}
  };

  const deleteAgent = async () => {
    setIsDeleting(true);
    let response = await commonApiCall(
      API_POINT + `/removeMyAgent?agentId=${agentId}`,
      "",
      "put",
      null,
      true
    );
    if (response?.data?.status?.code === 200) {
      setPage({
        totalItemsCount: 1,
        activePage: 1,
        perPage: 5,
        pageRangeDisplayed: null,
        itemsCountPerPage: null,
      });
      setDeleteModel(false);
      setIsDeleting(false);
      setTopPerformanceRender(true);
      getMyAgents(page.perPage, page.activePage, search, sort, productSort);
      showSuccessToast(response?.data?.status?.message);
    } else {
      setDeleteModel(false);
      setIsDeleting(false);
      showErrorToast(response?.data?.status?.message);
    }
  };
  const removeUnassignedAgent = async () => {
    setIsDeleting(true);
    let response = await commonApiCall(
      API_POINT + `/removeUnassgnedAgents?inviteCode=${inviteCode}`,
      "",
      "delete",
      null,
      true
    );
    if (response?.data?.status?.code === 200) {
      setPage({
        totalItemsCount: 1,
        activePage: 1,
        perPage: 5,
        pageRangeDisplayed: null,
        itemsCountPerPage: null,
      });
      setShowRemoveModel(false);
      setIsDeleting(false);
      getMyAgents(page.perPage, page.activePage, search, sort, productSort);
      showSuccessToast(
        response?.data?.status?.message || "Agent removed successfully."
      );
      setInviteCode(null);
    } else {
      setShowRemoveModel(false);
      setIsDeleting(false);
      setInviteCode(null);
      showErrorToast(response?.data?.status?.message);
    }
  };
  const removeMyAgent = async () => {
    let agentIds = [];
    if (agentId) {
      agentIds = [agentId];
    } else if (selectedRows?.length) {
      agentIds = Array.from(selectedRows, ({ Id }) => Id);
    }
    setIsDeleting(true);
    let response = await commonApiCall(
      API_POINT + `/removeMyAgent`,
      agentIds,
      "put",
      null,
      true
    );
    if (response?.data?.status?.code === 200) {
      setPage({
        totalItemsCount: 1,
        activePage: 1,
        perPage: 5,
        pageRangeDisplayed: null,
        itemsCountPerPage: null,
      });
      setShowRemoveModel(false);
      setIsDeleting(false);
      getMyAgents(page.perPage, page.activePage, search, sort, productSort);
      showSuccessToast(
        response?.data?.status?.message || "Agent removed successfully."
      );
    } else {
      setShowRemoveModel(false);
      setIsDeleting(false);
      showErrorToast(response?.data?.status?.message);
    }
  };
  const resendInvite = async (row) => {
    setIsActivityInMoreOption(true);
    let response = await commonApiCall(
      API_POINT + `/reinviteAgent?inviteCode=${row?.RepresentativeCode}`,
      "",
      "get",
      null,
      true
    );
    if (response.data.status.code === 200) {
      setIsActivityInMoreOption(false);
      getMyAgents(page.perPage, page.activePage, search, sort, productSort);
      showSuccessToast(response.data.status.message);
    } else {
      setIsActivityInMoreOption(false);
      showErrorToast(response.data.status.message);
    }
  };

  const getMyAgents = async (size, page, search, sort, productSort) => {
    setSelectedRows([]);
    setAgentListLoader(true);
    const startDate = dateFilter.startDate
      ? moment(dateFilter.startDate).format("YYYY-MM-DD")
      : "";
    const endDate = dateFilter.endDate
      ? moment(dateFilter.endDate).format("YYYY-MM-DD")
      : "";

    let response = await commonApiCall(
      API_POINT +
        `/getMyAgents?pageNo=${page ? page - 1 : 0}&size=${
          size ? size : 10
        }&searchText=${search}&sort=${sort}&sortColumn=${productSort}&interval=${filterType}&startDate=${startDate}&endDate=${endDate}`,
      "",
      "get",
      null,
      true
    );
    if (response.data.status.code === 200) {
      if (startDate && endDate) {
        setDateValue(null);
        // setDateFilter({ startDate: "", endDate: "" });
        setSearchDateFilter(false);
      }
      downLoadCSV(search, startDate, endDate);
      const managerialViewList =
        response.data.data?.agents &&
        response.data.data.agents?.map((obj) => {
          return {
            createdDate: obj.date
              ? formatDateInTimezone(
                  obj.date,
                  planData?.timeZoneId ?? null
                ).format("MM/DD/YYYY")
              : "N/A",
            firstName:
              obj.firstName || obj.lastName
                ? decryptData(obj.firstName) + " " + decryptData(obj.lastName)
                : "N/A",
            email: obj.email ? decryptData(obj.email) : "N/A",
            Phone: obj.mobile ? decryptData(obj.mobile) : "N/A",
            DriverLicenseNumber: obj.drivingLicense
              ? decryptData(obj.drivingLicense)
              : "N/A",
            agentType:
              obj.type.charAt(0).toUpperCase() +
              obj.type.substr(1).toLowerCase(),
            Id: obj.id,
            PaymentByManager: obj.paymentByManager,
            PaymentDone: obj.paymentDone,
            PaymentRequired: obj.paymentRequired,
            subscriptionPaidBy: obj.freeUser,
            RepresentativeCode: obj.referralCode ? obj.referralCode : "",
            emailsCount: obj?.emailSentCount,
            callsCount: obj?.callsCount,
            textMessageCount: obj?.textMessageCount,
            clientsCount: obj?.clientCount,
            policyPaidCount: obj?.policyPaidCount,
            quotesRunCount: obj?.quotesRunCount,
            submittedCount: obj?.submittedCount,
            recentActivitesCount: obj?.recentActivitesCount,
            applicationsCount: obj?.applicationsCount,
          };
        });

      setAgentPayoutHistories(managerialViewList ? managerialViewList : []);
      setChangePayerValue({
        ...changePayerValue,
        freeAcountRemaining: response.data.data?.freeAcountRemaining,
        freeChildPrice: response.data.data?.freeChildPrice,
      });
      setPage({
        ...page,
        perPage: response.data.data?.recordsPerPage,
        activePage: response.data.data?.pageNo + 1,
        totalItemsCount: response.data.data?.totalRecord,
        itemsCountPerPage: response.data.data?.recordsPerPage,
      });
    } else {
      setAgentPayoutHistories([]);
    }
    setAgentListLoader(false);
  };

  const handleChange = (recoder_per_page) => {
    getMyAgents(Number(recoder_per_page.value), 0, search, sort, productSort);
    setPage({
      ...page,
      activePage: 1,
      perPage: Number(recoder_per_page.value),
    });
  };

  const handlePageChange = (pageNumber) => {
    setPage({ ...page, activePage: pageNumber });
    getMyAgents(Number(page.perPage), pageNumber, search, sort, productSort);
  };

  const handleChangeInvite = (e) => {
    if (e.target.name === "agentType" && e.target.value) {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
        errors: Object.assign(formData.errors, { [e.target.name]: "" }),
        referralFees: "",
      });
    } else if (e.target.name !== "agentType" && e.target.value) {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
        errors: Object.assign(formData.errors, { [e.target.name]: "" }),
      });
    } else
      setFormData({
        ...formData,
        [e.target.name]: "",
      });
  };

  const validateForm = () => {
    const { email, agentType, errors, paymentType } = formData;
    if (formData.hasOwnProperty("email")) {
      if (isEmpty(email)) errors.email = errorMessages.PROVIDE_EMAIL;
      else if (!validateEmail(email, true))
        errors.email = errorMessages.PROVIDE_VALID_EMAIL;
      else delete errors.email;
    }
    if (formData.hasOwnProperty("agentType")) {
      if (isEmpty(agentType)) errors.agentType = "Please select agent type";
      else delete errors.agentType;
    }
    if (formData.hasOwnProperty("paymentType")) {
      if (isEmpty(paymentType))
        errors.paymentType = "Please select payment type";
      else delete errors.paymentType;
    }
    const isFormValid = Object.keys(errors).length !== 0 ? false : true;
    setFormData({
      ...formData,
      errors: errors,
    });
    return isFormValid;
  };

  const changePaymentType = async (type) => {
    setIsChangeInInviteModel(true);
    try {
      let response = await commonApiCall(
        API_POINT + `/changePaymentType?paymentType=${type}`,
        "",
        "get",
        null,
        true
      );
      if (response.data.status.code === 200) {
        setIsChangeInInviteModel(false);
        setFormData({
          ...formData,
          paymentType:
            response.data.data.paymentType &&
            paymentTypeOptions.filter(
              (x) => x.value === response.data.data.paymentType
            ),
        });
      }
    } catch (err) {
      setIsChangeInInviteModel(false);
      showErrorToast(err);
    }
  };

  const intialValueOfFied = () => {
    setIsChangeInInviteModel(false);
    setShowInviteModel(false);
    setFormData({
      ...formData,
      email: "",
      agentType: { value: "professional-plus", label: "Pro+", key: "Pro+" },
      paymentType: null,
      referralFees: "",
      errors: {},
    });
  };

  const inviteAgent = async (row) => {
    try {
      // const { email, agentType, paymentType } = formData;
      // let body = {
      //   email: await encryptData(email),
      //   paymentByManager:
      //     agentType?.value === "professional-plus" &&
      //     paymentType[0].value === "agent"
      //       ? true
      //       : agentType?.value === "professional-plus" &&
      //         paymentType[0].value === "pro_plus"
      //       ? false
      //       : null,
      //   agentType: agentType.value ? agentType.value : "",
      //   referralCommision: "Agent",
      // };
      const { email } = formData;
      const emailArr = email.split(",").map((e) => encryptData(e.trim()));
      let body = {
        email: emailArr,
        paymentByManager: null,
        agentType: "professional-plus",
        referralCommision: "Agent",
      };

      if (validateForm()) {
        setIsChangeInInviteModel(true);
        let response = await commonApiCall(
          API_POINT + "/inviteAgent",
          body,
          "post",
          null,
          true
        );
        if (response.data.status.code === 200) {
          intialValueOfFied();
          showSuccessToast(response.data.status.message);
          getMyAgents(page.perPage, page.activePage, search, sort, productSort);
        } else {
          intialValueOfFied();
          showErrorToast(response.data.status.message);
          if (response.data.status.code === 400)
            getMyAgents(
              page.perPage,
              page.activePage,
              search,
              sort,
              productSort
            );
        }
      }
    } catch (err) {
      intialValueOfFied();
      showErrorToast(err);
    }
  };
  const changePayer = async (row, paidBy) => {
    try {
      setIsActivityInMoreOption(true);
      let body = {
        email: await await encryptData(row?.email),
        paymentByManager:
          paidBy === "manager" ? true : paidBy === "agent" ? false : null,
      };
      let response = await commonApiCall(
        API_POINT + "/changePayer ",
        body,
        "post",
        null,
        true
      );
      if (response.data.status.code === 200) {
        setIsActivityInMoreOption(false);
        showSuccessToast(response.data.status.message);
        getMyAgents(page.perPage, page.activePage, search, sort, productSort);
      } else {
        setIsActivityInMoreOption(false);
        showErrorToast(response.data.status.message);
      }
    } catch (err) {
      setIsActivityInMoreOption(false);
      showErrorToast(err);
    }
  };
  const keyPressed = (event) => {
    let value = event.target.value;
    setPage({
      ...page,
      activePage: 1,
    });
    if (event.key === "Enter") {
      getMyAgents(page.perPage, page.activePage, value, sort, productSort);
    }
  };
  const clearSearch = () => {
    setSearch("");
    getMyAgents(page.perPage, page.activePage, "", sort, productSort);
  };

  const downLoadCSV = async (searchBy, startDate, endDate) => {
    setIsCsvDataLoading(true);
    let API_URL =
      API_POINT +
      "/getAgencyApplicationsCsv" +
      "?searchText=" +
      searchBy +
      "&interval=" +
      filterType +
      "&startDate=" +
      startDate +
      "&endDate=" +
      endDate;

    let response = await commonApiCall(API_URL, "", "post", null, true);
    if (response.data.status.code === 200) {
      const csvDataArr = response.data.data.map((item) => ({
        "Agent Name": item.firstName
          ? item.firstName + " " + item.lastName
          : "N/A",
        "Recent Actiivites": item.recentActivitiesCount
          ? item.recentActivitiesCount
          : 0,
        "Applications Submitted": item.submittedApplicationsCount
          ? item.submittedApplicationsCount
          : 0,
        "Total Applications": item.totalApplicationsCount
          ? item.totalApplicationsCount
          : 0,
        "Policies Paid": item.policyPaidCount ? item.policyPaidCount : 0,
        "Calls Made": item.callsCount ? item.callsCount : 0,
        Applicants: item.clientCount ? item.clientCount : 0,
        "Signup Date": item.signupDate,
        Email: item.email,
      }));
      setCsvData(csvDataArr);
      setIsCsvDataLoading(false);
    }
  };

  const Checkbox = React.forwardRef(({ onClick, ...rest }, ref) => {
    return (
      <div>
        <span className='custom-checkbox text-center'>
          <label className='m-0'>
            <input
              type='checkbox'
              name={"checkbox-row"}
              ref={ref}
              onClick={onClick}
              {...rest}
            />
            <span></span>
          </label>
        </span>
      </div>
    );
  });

  const handleRowSelected = React.useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const handleFilter = (newDate) => {
    const startDate = newDate?.start?.format("YYYY-MM-DD");
    const endDate = newDate?.end?.format("YYYY-MM-DD");
    setDateValue(newDate);
    setDateFilter({ startDate: startDate, endDate: endDate });

    setAgencyFilters({
      ...selected_agency_filter,
      dateOption: { startDate: startDate, endDate: endDate },
    });
  };

  useEffect(() => {
    setAgencyFilters({
      value: "all",
      dateOption: { starteDate: "", endDate: "" },
    });
    setDateModal(false);

    return () => {
      setAgencyFilters({
        value: "all",
        dateOption: { starteDate: "", endDate: "" },
      });
      setDateModal(false);
    };
  }, []);

  useEffect(() => {
    setFilterType(selected_agency_filter?.value);
    if (selected_agency_filter?.value === "custom") {
      setDateModal(true);
    } else {
      setDateFilter({ startDate: "", endDate: "" });
      setDateModal(false);
    }
  }, [selected_agency_filter]);

  const columnsCustomStyles = {
    headCells: {
      style: {
        paddingLeft: "3px", // override the cell padding for head cells
        paddingRight: "3px",
      },
    },
    cells: {
      style: {
        paddingLeft: "3px", // override the cell padding for data cells
        paddingRight: "3px",
      },
    },
  };
  const dtatable_padding = 6;

  const managerialViewColumns = [
    {
      name: "Agent Name",
      selector: (row) => row.firstName,
      field: "firstName",
      // width: "180px",
      minWidth: `${230 + dtatable_padding}px`,
      sortable: true,
      omit: !checkColumnOmit("agent_name"),
      cell: (row) => (
        <span
          style={{
            cursor: "pointer",
            pointerEvents: "none",
            wordBreak: "keep-all",
          }}
        >
          {row.firstName}
        </span>
      ),
    },
    {
      name: "Recent Activities",
      selector: (row) => row.recentActivities,
      field: "recentActivities",
      // width: "180px",
      minWidth: `${150 + dtatable_padding}px`,
      sortable: true,
      cell: (row) => {
        return (
          <span
            className='wordBreak'
            style={{
              cursor: "pointer",
              pointerEvents: "none",
            }}
          >
            {row.recentActivitesCount ?? 0}{" "}
            {/* {applicationPercentage > 0 && filterType !== "all" && (
              <span className='highicon'>↑ {applicationPercentage}%</span>
            )}
            {applicationPercentage < 0 && filterType !== "all" && (
              <span className='low-icon'>↓ 20%</span>
            )} */}
          </span>
        );
      },
      omit: !checkColumnOmit("recent_activities"),
    },
    {
      name: "Applications Submitted",
      selector: (row) => row.submittedApplications,
      field: "submittedApplications",
      minWidth: `${180 + dtatable_padding}px`,
      //minWidth: "250px",
      sortable: true,
      cell: (row) => (
        <span
          className='wordBreak'
          style={{
            cursor: "pointer",
            pointerEvents: "none",
          }}
        >
          {row.submittedCount}
        </span>
      ),
      omit: !checkColumnOmit("applications_submitted"),
    },
    {
      name: "Total Applications",
      selector: (row) => row.applicationsCount,
      field: "applicationsCount",
      minWidth: "180px",
      minWidth: `${150 + dtatable_padding}px`,
      sortable: true,
      cell: (row) => (
        <span
          className='wordBreak'
          style={{
            cursor: "pointer",
            pointerEvents: "none",
          }}
        >
          {row.applicationsCount}
        </span>
      ),
      omit: !checkColumnOmit("total_applications"),
    },
    {
      name: "Policies Paid",
      selector: (row) => row.policiesPaid,
      field: "policiesPaid",
      minWidth: `${150 + dtatable_padding}px`,
      // minWidth: "180px",
      sortable: true,
      cell: (row) => {
        return (
          <span
            className='wordBreak'
            style={{
              cursor: "pointer",
              pointerEvents: "none",
            }}
          >
            {row.policyPaidCount}
          </span>
        );
      },
      omit: !checkColumnOmit("policies_paid"),
    },
    {
      name: "Calls Made",
      selector: (row) => row.callsCount,
      field: "callsCount",
      sortable: true,
      minWidth: `${150 + dtatable_padding}px`,
      // minWidth: "120px",
      cell: (row) => (
        <span
          className='wordBreak'
          style={{
            cursor: "pointer",
            pointerEvents: "none",
          }}
        >
          {row.agentType === "Ambassador" ? 0 : row.callsCount}
        </span>
      ),
      // width: "100px",
      omit: !checkColumnOmit("calls_made"),
    },
    {
      name: "Applicants",
      selector: (row) => row.clientsCount,
      field: "clientsCount",
      sortable: true,
      minWidth: `${110 + dtatable_padding}px`,
      cell: (row) => (
        <span
          className='wordBreak'
          style={{
            cursor: "pointer",
            pointerEvents: "none",
          }}
        >
          {row.agentType === "Ambassador" ? 0 : row.clientsCount}
        </span>
      ),
      // width: "100px",
      omit: !checkColumnOmit("applicants"),
    },
    {
      name: "Signup Date",
      selector: (row) => row.createdDate,
      field: "createdDate",
      minWidth: `${110 + dtatable_padding}px`,
      omit: !checkColumnOmit("signup_date"),
      sortable: true,
      cell: (row) => (
        <>
          {row.createdDate === "N/A" ? (
            <span className='text-green'>{"Invite sent"}</span>
          ) : (
            row.createdDate
          )}
        </>
      ),
    },
    // {
    //   name: "Paid By",
    //   selector: (row) => row.subscriptionPaidBy,
    //   field: "subscriptionPaidBy",
    //   minWidth: "110px",
    //   sortable: true,
    //   cell: (row) => (
    //     <span
    //       className="wordBreak"
    //       style={{
    //         cursor: "pointer",
    //         pointerEvents: "none",
    //       }}
    //     >
    //       {row.agentType === "Ambassador" ? "-" : row.subscriptionPaidBy}
    //     </span>
    //   ),
    //   omit: subscriptionPaidBy,
    // },
    // {
    //   name: "Email",
    //   selector: (row) => row.email,
    //   field: "email",
    //   minWidth: "220px",
    //   sortable: true,
    //   cell: (row) => (
    //     <span
    //       //className='wordBreak'
    //       style={{
    //         cursor: "pointer",
    //         pointerEvents: "none",
    //       }}
    //     >
    //       {row.email}
    //     </span>
    //   ),
    // },
    // {
    //   name: "Agent Type",
    //   selector: (row) => row.agentType,
    //   field: "agentType",
    //   sortable: true,
    //   minWidth: "130px",
    //   omit: agentType,
    // },
    // {
    //   name: "Emails Sent",
    //   selector: (row) => row.emailsCount,
    //   field: "emailsCount",
    //   sortable: true,
    //   //minWidth: "150px",
    //   width: "145px",
    //   cell: (row) => (
    //     <span
    //       className='wordBreak'
    //       style={{
    //         cursor: "pointer",
    //         pointerEvents: "none",
    //       }}
    //     >
    //       {row.agentType === "Ambassador" ? "-" : row.emailsCount}
    //     </span>
    //   ),
    //   // width: "100px",
    //   omit: emailsCount,
    // },

    // {
    //   name: "Texts Sent",
    //   selector: (row) => row.textMessageCount,
    //   field: "textMessageCount",
    //   sortable: true,
    //   minWidth: "120px",
    //   cell: (row) => (
    //     <span
    //       className='wordBreak'
    //       style={{
    //         cursor: "pointer",
    //         pointerEvents: "none",
    //       }}
    //     >
    //       {row.agentType === "Ambassador" ? "-" : row.textMessageCount}
    //     </span>
    //   ),
    //   // width: "100px",
    //   omit: textSent,
    // },
    {
      name: (
        <>
          <div
            className='setting-dropdown'
            style={{ top: "3px", right: "-3px" }}
          >
            <span
              className={`material-icons cursor-pointer ${
                isSetting ? "active" : null
              }`}
              onClick={settinghandler}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                version='1.1'
                width='15px'
                height='16px'
              >
                <g transform='matrix(1 0 0 1 -150 0 )'>
                  <path
                    d='M 14.985317114652672 10.377409695077642  C 15.032703403595017 10.19999101703748  14.963203323343679 10.012895742567983  14.808408109785947 9.922573508012986  C 14.808408109785947 9.922573508012986  13.462637311008065 9.129027951164677  13.462637311008065 9.129027951164677  C 13.598478012001598 8.38064368463895  13.598478012001598 7.612904333294981  13.462637311008065 6.864520066769253  C 13.462637311008065 6.864520066769253  14.808408109785947 6.070975002138068  14.808408109785947 6.070975002138068  C 14.963203323343679 5.980652767583073  15.032703211532898 5.793556708642533  14.982157835907879 5.619363821672197  C 14.631499285683573 4.470981154852122  14.034432659608813 3.432275169061201  13.254138410922963 2.567762362494532  C 13.134093147108727 2.4355048055773123  12.938229245553567 2.403247010242423  12.786593114912586 2.4935692447974187  C 12.786593114912586 2.4935692447974187  11.440822316134701 3.287114555537166  11.440822316134701 3.287114555537166  C 10.875345946807014 2.7903422693301354  10.224574594809889 2.406472809003143  9.520098456635614 2.154860859448015  C 9.520098456635614 2.154860859448015  9.520098456635614 0.5709957367844316  9.520098456635614 0.5709957367844316  C 9.520098456635614 0.39035126767444017  9.39689429820082 0.23228740527127623  9.223144572078892 0.19357787397888018  C 8.063760011854285 -0.0709372398555589  6.875943871079575 -0.058034075576247804  5.7734228334838695 0.19357787397888018  C 5.59967310736194 0.23228740527127623  5.476468948927146 0.39035126767444017  5.476468948927146 0.5709957367844316  C 5.476468948927146 0.5709957367844316  5.476468948927146 2.1580866043724876  5.476468948927146 2.1580866043724876  C 4.775151848478536 2.4129243449974433  4.1243798336788045 2.7967937899426505  3.555744366370672 3.2903403004616383  C 3.555744366370672 3.2903403004616383  2.2131328463375795 2.496794989721891  2.2131328463375795 2.496794989721891  C 2.0583376327798484 2.406472755166895  1.8656335371988282 2.4355050055405187  1.7455882733845918 2.570988353527566  C 0.9652940246987406 3.4322754151697628  0.36822684126724387 4.470980785689279  0.01756829104293862 5.622589320488107  C -0.03613617126475462 5.796782207458444  0.03652280360713726 5.983878266398982  0.1913180171648682 6.074200500953977  C 0.1913180171648682 6.074200500953977  1.5370886502421022 6.867746057802288  1.5370886502421022 6.867746057802288  C 1.4012479492485699 7.616130324328015  1.4012479492485699 8.383869675671983  1.5370886502421022 9.132253942197712  C 1.5370886502421022 9.132253942197712  0.1913180171648682 9.925798514611772  0.1913180171648682 9.925798514611772  C 0.03652280360713726 10.016120749166767  -0.032977084582080214 10.203216808107307  0.01756829104293862 10.377409695077642  C 0.36822684126724387 11.525792361897716  0.9652940246987406 12.564498347688641  1.7455882733845918 13.429011154255308  C 1.8656335371988282 13.561268711172529  2.061496715696599 13.593527244833105  2.2131328463375795 13.503205010278108  C 2.2131328463375795 13.503205010278108  3.5589036451154645 12.709659453429799  3.5589036451154645 12.709659453429799  C 4.124380014443152 13.20643173963683  4.775152089497666 13.590301446072383  5.479628227671939 13.841913395627511  C 5.479628227671939 13.841913395627511  5.479628227671939 15.42900352488988  5.479628227671939 15.42900352488988  C 5.479628227671939 15.609647993999872  5.602832386106733 15.767712302474806  5.776582112228662 15.806421833767201  C 6.935966672453268 16.07093694760164  8.123782813227978 16.05803378332233  9.226303850823685 15.806421833767201  C 9.400053576945615 15.767712302474806  9.523257735380406 15.609647993999872  9.523257735380406 15.42900352488988  C 9.523257735380406 15.42900352488988  9.523257735380406 13.841913395627511  9.523257735380406 13.841913395627511  C 10.224574835829017 13.587075655002558  10.875346127571362 13.203205963948788  11.443981594879494 12.709659453429799  C 11.443981594879494 12.709659453429799  12.789752393657379 13.503205010278108  12.789752393657379 13.503205010278108  C 12.944547607215108 13.593527244833105  13.137251461777002 13.564494502242356  13.257296725591237 13.429011154255308  C 14.037590974277087 12.567724092613112  14.634658564428365 11.529018229876469  14.985317114652672 10.377409695077642  Z M 10.025552205353955 7.996774008966964  C 10.025552205353955 9.419349178212746  8.89144079050161 10.5774093259148  7.498283943800509 10.5774093259148  C 6.105127097099408 10.5774093259148  4.971015200208806 9.419349178212746  4.971015200208806 7.996774008966964  C 4.971015200208806 6.574198839721182  6.105127097099408 5.416138692019129  7.498283943800509 5.416138692019129  C 8.89144079050161 5.416138692019129  10.025552205353955 6.574198839721182  10.025552205353955 7.996774008966964  Z '
                    fill-rule='nonzero'
                    fill='#9b9b9b'
                    stroke='none'
                    transform='matrix(1 0 0 1 150 0 )'
                  />
                </g>
              </svg>
            </span>

            <div
              className={`settinglist text-left ${
                isSetting ? " d-block" : "d-none"
              }`}
              onMouseLeave={() => setSetting(false)}
            >
              <ul>
                {/* {checkAccess(planData, "CUSTOM_COLUMNS") && (
                  <li
                    className={`create-new-col`}
                    onClick={() => setColumnModal(true)}
                  >
                    <span className='material-icons'>add</span>
                    <span className='creat-text'> Create New Column</span>
                  </li>
                )} */}
                {checkedColumns?.map((data) => {
                  return generateCheckBox(
                    data.columnName,
                    data.columnName,
                    data.isActive,
                    data.columnType,
                    data.id
                  );
                })}
              </ul>
            </div>
          </div>
        </>
      ),
      sortable: false,
      ignoreRowClick: true,
      width: "55px",
      id: "sticky",
      cell: (row) => (
        <>
          {row.createdDate === "N/A" ? (
            <ShowMoreOptions
              showPayerOption={showPayerOption}
              ChangePayer={ChangePayer}
              row={row}
              setAgentId={setAgentId}
              setShowMoreOption={setShowMoreOption}
              showMoreOption={showMoreOption}
              setShowPayerOption={setShowPayerOption}
              agentId={agentId}
              ResendInviteImage={ResendInviteImage}
              cancelInvite={cancelInvite}
              setIsCardDetails={setIsCardDetails}
              setDeleteModel={setDeleteModel}
              resendInvite={resendInvite}
              removeUnassignedAgent={removeUnassignedAgent}
              setInviteCode={setInviteCode}
              setShowRemoveModel={setShowRemoveModel}
              changePayer={changePayer}
              changePayerValue={changePayerValue}
            />
          ) : null}
        </>
      ),
    },
  ];

  const handleMultipleArchive = async () => {
    const selectedRowsData = await Promise.all(
      selectedRows?.map((obj) => {
        return {
          agentId: obj.id,
        };
      })
    );

    const API_URl = API_POINT_UNDERWRITE + `/agentStatus`;

    let response = await commonApiCall(
      API_URl,
      selectedRowsData,
      "put",
      null,
      true
    );
    if (response.status === 200) {
      showSuccessToast(response.data.status.message);
      await getMyAgents(
        page.perPage,
        page.activePage,
        search,
        sort,
        productSort
      );
    }
  };

  useEffect(() => {
    if (formData?.paymentType) {
      setShowInviteModel(true);
    }
  }, [formData]);

  useEffect(() => {
    if (checkAccess(planData, "agent_dashboard")) {
      window.scrollTo(0, 0);
      getLeadStatistics();
     if (filterType !== "custom") {
        getMyAgents(page.perPage, page.activePage, search, sort, productSort);
      }
    }
  }, [planData, sort, productSort, filterType]);

  useEffect(() => {
    if (sign_in && checkAccess(planData, "agent_dashboard")) {
      const path = window.location.pathname;
      const eventObject = {
        agent_id: sign_in?.data?.id,
        page: path,
      };
      segmentTracking("agent_team", eventObject);
      fetchColumns();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sign_in]);

  const conditionalRowStyles = [
    {
      when: (row) =>
        row.createdDate === "N/A" ||
        (!row.PaymentDone && row.PaymentByManager && row.PaymentRequired),
      style: {
        cursor: "auto",
      },
    },
  ];
  return (
    <React.Fragment>
      <Layout>
        <div className='row' style={{ marginTop: "28px" }}>
          {planData && !checkAccess(planData, "agent_dashboard") ? (
            <AccessDenied />
          ) : (
            <div className='col-lg-12 content-container'>
              {isInvitingModel || isActivityInMoreOption ? (
                <LeafLoader />
              ) : null}

              <div className='d-flex justify-content-between search-bar-wrapper mt-3'>
                <div className='search-bar'>
                  <Search
                    className='bg-white'
                    search={search}
                    setSearch={setSearch}
                    keyPressed={keyPressed}
                    clearSearch={() => clearSearch()}
                  />
                </div>
                <div className='d-flex align-items-center'>
                  <CSVLink
                    id='CSV-download'
                    // className={isCsvDataLoading ? "grayscale" : "hover-primary"}
                    data={csvData}
                    filename={
                      "Applications-" + moment().format("MM/DD/YYYY") + ".csv"
                    }
                    onClick={(event) => {
                      let rType = "";
                      if (csvData.length > 0) {
                        rType = true;
                      } else {
                        rType = false;
                      }
                      return rType;
                    }}
                  >
                    <OverlayTrigger
                      placement='bottom-start'
                      // className='hover-primary'
                      delay={{ show: 250, hide: 400 }}
                      overlay={
                        isCsvDataLoading
                          ? renderTooltiptext(
                              "popover-basic",
                              "Preparing CSV file for download. This may take up to 1 minute."
                            )
                          : renderTooltiptext(
                              "popover-basic",
                              "Download CSV for Agents."
                            )
                      }
                    >
                      <div className='upload-contacts font-weight-semibold '>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          version='1.1'
                          width='15px'
                          height='15px'
                        >
                          <g transform='matrix(1 0 0 1 -954 -245 )'>
                            <path
                              d='M 13.59375 15  L 1.40625 15  C 1.0312500000000004 15  0.703125 14.859375000000002  0.42187500000000017 14.578125  C 0.14062500000000033 14.296875000000004  0 13.968750000000002  0 13.59375  L 0 10.2421875  L 1.40625 10.2421875  L 1.40625 13.59375  L 13.59375 13.59375  L 13.59375 10.2421875  L 15 10.2421875  L 15 13.59375  C 15 13.968750000000002  14.859375000000002 14.296875000000004  14.578125 14.578125  C 14.296875000000004 14.859375000000002  13.968750000000002 15  13.59375 15  Z M 12.0234375 6.890625  L 7.5 11.4140625  L 2.9765625 6.890625000000002  L 3.984375 5.882812500000002  L 6.796875 8.695312500000002  L 6.796875 0  L 8.203125 0  L 8.203125 8.6953125  L 11.015625 5.8828125  L 12.0234375 6.890625  Z '
                              fillRule='nonzero'
                              fill='#929090'
                              stroke='none'
                              transform='matrix(1 0 0 1 954 245 )'
                            />
                          </g>
                        </svg>
                        {/* Download CSV */}
                      </div>
                    </OverlayTrigger>
                  </CSVLink>
                  <div className='d-flex'>
                    <div className='invite-agent-btn add-contact-dropdown ml-4'>
                      <button
                        type='button'
                        className='btn btn-primary'
                        onClick={() => getUserProfileDetails()}
                      >
                        <span className='material-icons'>add</span> Invite
                        Agents
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className='show-datatable-view'>
                {agentListLoader ? (
                  <TransactionTableLoader
                    displayRows='10'
                    displayColumns='10'
                  />
                ) : (
                  <>
                    <DataTable
                      columns={managerialViewColumns}
                      data={managerialViewList}
                      customStyles={columnsCustomStyles}
                      className='agent-table custom-datatable enterprise-agent lg-min-width row-clickable'
                      pagination={false}
                      onRowClicked={(row) => navigateToAgentDetails(row)}
                      conditionalRowStyles={conditionalRowStyles}
                      onSort={(columns) => {
                        setSort(sort === "asc" ? "desc" : "asc");
                        setProductSort(columns.field);
                      }}
                      clearSelectedRows={clearSelectedRows}
                      selectableRows={true}
                      selectableRowsComponent={Checkbox}
                      onSelectedRowsChange={handleRowSelected}
                      selectableRowDisabled={(row) => row.createdDate === "N/A"}
                      noDataComponent='No matching records found'
                    />

                    {selectedRows?.length ? (
                      <BottomToaster
                        message={`${selectedRows.length} ${
                          selectedRows?.length == 1 ? "person " : "people "
                        }
                        selected:`}
                        actionJSX={
                          <>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              version='1.1'
                              width='14px'
                              height='14px'
                            >
                              <g transform='matrix(1 0 0 1 -668 -18 )'>
                                <path
                                  d='M 9.545454545454545 6.363636363636363  C 9.545454545454545 6.363636363636363  4.454545454545454 6.363636363636363  4.454545454545454 6.363636363636363  C 4.285771318457344 6.363636363636363  4.123909862204031 6.430681750178337  4.004568533463911 6.550023078918457  C 3.8852272047237917 6.669364407658577  3.818181818181818 6.831225863911889  3.818181818181818 7  C 3.818181818181818 7.1687741360881105  3.8852272047237917 7.330635592341423  4.004568533463911 7.449976921081543  C 4.123909862204031 7.569318249821663  4.285771318457344 7.636363636363636  4.454545454545454 7.636363636363636  C 4.454545454545454 7.636363636363636  9.545454545454545 7.636363636363636  9.545454545454545 7.636363636363636  C 9.714228681542657 7.636363636363636  9.876090744679624 7.569318249821663  9.995432073419744 7.449976921081543  C 10.114773402159864 7.330635592341423  10.181818181818182 7.1687741360881105  10.181818181818182 7  C 10.181818181818182 6.831225863911889  10.114773402159864 6.669364407658577  9.995432073419744 6.550023078918457  C 9.876090744679624 6.430681750178337  9.714228681542657 6.363636363636363  9.545454545454545 6.363636363636363  Z M 7 0  C 10.86590896953236 0  14 3.13409103046764  14 7  C 14 10.86590896953236  10.86590896953236 14  7 14  C 3.13409103046764 14  0 10.86590896953236  0 7  C 0 3.13409103046764  3.13409103046764 0  7 0  Z M 12.291310570456766 9.191732406616211  C 12.579132957891984 8.496867689219387  12.727272738480133 7.752116149122065  12.727272727272727 7  C 12.72727270463835 5.48103287003257  12.123864845796065 4.024278749119151  11.049792896617543 2.9502067999406294  C 9.97572094743902 1.8761348507621072  8.518967129967429 1.272727424448187  7 1.2727274244481868  C 5.48103287003257 1.2727274244481859  4.024278445677324 1.8761348507621072  2.9502064964988013 2.9502067999406294  C 1.876134547320279 4.024278749119151  1.2727272953616469 5.48103287003257  1.2727272727272727 7  C 1.2727272615198688 7.752116149122065  1.4208674972707576 8.496867689219387  1.708689884705977 9.191732406616211  C 1.9965122721411965 9.886597124013035  2.4183800491419705 10.517966449260712  2.9502064964988013 11.049792896617543  C 3.4820329438556326 11.581619343974374  4.113402875986966 12.003488164056431  4.808267593383789 12.291310570456766  C 5.503132310780612 12.579132976857098  6.247883850877935 12.727272727272727  7 12.727272727272727  C 7.752116149122065 12.727272727272727  8.496867689219387 12.579132976857098  9.191732406616211 12.291310570456766  C 9.886597124013035 12.003488164056431  10.517966449260712 11.581619343974374  11.049792896617543 11.049792896617543  C 11.581619343974374 10.517966449260712  12.003488183021545 9.886597124013035  12.291310570456766 9.191732406616211  Z '
                                  fill-rule='nonzero'
                                  fill='#f5f5f7'
                                  stroke='none'
                                  transform='matrix(1 0 0 1 668 18 )'
                                />
                              </g>
                            </svg>
                            <span>
                              {" "}
                              {selectedRows?.length == 1
                                ? "Remove Agent"
                                : "Remove Agents"}{" "}
                            </span>
                          </>
                        }
                        actionHandler={() => setShowRemoveModel(true)}
                      />
                    ) : null}
                  </>
                )}
                {managerialViewList.length ? (
                  <div className='pagination-block'>
                    <div className='pagination-left'>
                      Show
                      <div className='default-select' style={{ width: "85px" }}>
                        <Select
                          onChange={handleChange}
                          options={paginationDropdown}
                          defaultValue={{
                            label: page.perPage,
                            value: page.perPage,
                          }}
                          isSearchable={false}
                          className='custom-select-menu'
                        />
                      </div>
                      entries
                    </div>
                    <Pagination
                      activePage={page.activePage}
                      itemsCountPerPage={page.itemsCountPerPage}
                      totalItemsCount={page.totalItemsCount}
                      pageRangeDisplayed={3}
                      onChange={(e) => handlePageChange(e)}
                    />
                  </div>
                ) : null}
              </div>
              <Modal
                className='payment-model'
                show={isCardDetails}
                onHide={() => setIsCardDetails(false)}
                centered
                backdrop='static'
              >
                <Modal.Header closeButton>
                  <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <AuthorizePayment
                    onPayNow={payAgentSubscription}
                    loader={loader}
                    isCardDetails={isCardDetails}
                    onCancel={() => setIsCardDetails(false)}
                  ></AuthorizePayment>
                </Modal.Body>
              </Modal>
            </div>
          )}
        </div>

        {/* Invite Agent Modal */}
        <InviteAgentModel
          show={showInviteModel}
          intialValueOfFied={intialValueOfFied}
          agentTypeOptions={agentTypeOptions}
          paymentTypeOptions={paymentTypeOptions}
          formData={formData}
          handleChange={handleChangeInvite}
          changePaymentType={changePaymentType}
          inviteAgent={inviteAgent}
          isChangeInInviteModel={isChangeInInviteModel}
        />

        {showDateModal && (
          <DateFilterModel
            show={showDateModal}
            setDateModal={setDateModal}
            onHide={() => {
              setDateModal(false);
              setDateValue(null);
            }}
            handleFilter={handleFilter}
            filter={dateFilter}
            setSearchDateFilter={setSearchDateFilter}
            dateValue={dateValue}
            setFilterType={setFilterType}
            setDateFilter={setDateFilter}
            setAgencyFilters={setAgencyFilters}
            setDateValue={setDateValue}
            dateFilter={dateFilter}
            searchDateFilter={searchDateFilter}
            getMyAgents={() =>
              getMyAgents(
                page.perPage,
                page.activePage,
                search,
                sort,
                productSort
              )
            }
          />
        )}
        <DeleteModel
          show={showDeleteModel}
          onHide={setDeleteModel}
          isDeleting={isDeleting}
          deleteList={() => deleteAgent()}
          title={"Remove Agent"}
          // body={
          //   "Are you sure you want to remove this Agent? You will need to re-invite them to assign leads or view their activity."
          // }
          // subBody={
          //   "If the agency is paying for the agent or the agent is using a free seat, their leads will automatically be assigned to the Agency Owner."
          // }
          body={
            "Are you sure you want to remove these agents? You will need to re-invite them."
          }
        />
        <DeleteModel
          show={showRemoveModel}
          onHide={setShowRemoveModel}
          isDeleting={isDeleting}
          deleteList={() =>
            inviteCode ? removeUnassignedAgent() : removeMyAgent()
          }
          title={selectedRows?.length > 1 ? "Remove Agents" : "Remove Agent"}
          body={
            selectedRows?.length > 1
              ? "Are you sure you want to remove these agents? You will need to re-invite them."
              : "Are you sure you want to remove this agent? You will need to re-invite them."
          }
          btnText={"Remove"}
        />
        {/* <ColumnModel
          columnName={columnName}
          addColumn={addColumn}
          setColumnModal={setColumnModal}
          setcolumnName={setcolumnName}
          columnModal={columnModal}
        /> */}
      </Layout>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    sign_in: state.agentReducer.signIn,
    subscribed_plan: state.agentReducer.subscribedPlans.data
      ? state.agentReducer.subscribedPlans.data
      : "",
    agent_plan: state.agentReducer.agentPlan,
    planData: state.agentReducer.planDetails?.data?.data,
    selected_agency_filter: state.agentReducer.agencyFilter,
  };
};

export default connect(mapStateToProps, {
  commonApiCall,
  conversationDetails,
  commonApiCallHeaders,
  agentDetils,
  setAgencyFilters,
})(withRouter(MyAgents));
